import React from 'react';
import { Box } from '@mui/material';
import { FaChartLine, FaAddressCard, FaMapMarkedAlt } from 'react-icons/fa';
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../Common/ChartsContainer';
import ResultsWrapper from './Results';
import RegistersWrapper from './Registers/index';
import MappingWrapper from './Mapping';

const menus = [
    {
        title: 'Resultados',
        path: '/governanceroom/dashboardproductionesus/registers/results',
        icon: <FaChartLine size={20} style={{ gap: '5px' }} />
    },
    {
        title: 'Cadastros',
        path: '/governanceroom/dashboardproductionesus/registers/registers',
        icon: <FaAddressCard size={20} style={{ gap: '5px' }} />
    },
    {
        title: 'Mapeamento',
        path: '/governanceroom/dashboardproductionesus/registers/mapping',
        icon: <FaMapMarkedAlt size={20} style={{ gap: '5px' }} />
    }
];

const titleMap = {
    '/governanceroom/dashboardproductionesus/registers/results':
        'Evolução dos Resultados dos Cadastros: Domiciliar e Territorial x Individual',
    '/governanceroom/dashboardproductionesus/registers/registers':
        'Cadastros: Domiciliar/Territorial e Individual',
    '/governanceroom/dashboardproductionesus/registers/mapping': 'Mapeamento de Cadastros'
};

const Registers = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardesus');
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                    showRegisterTypeResults={
                        location.pathname === '/governanceroom/dashboardproductionesus/registers/results'
                    }
                    showRegisterTypeRegisters={
                        location.pathname === '/governanceroom/dashboardproductionesus/registers/registers'
                    }
                    showLocation={
                        location.pathname === '/governanceroom/dashboardproductionesus/registers/mapping'
                    }
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="results" replace />}
                        />
                        <Route path="results" element={<ResultsWrapper />} />
                        <Route path="registers" element={<RegistersWrapper />} />
                        <Route path="mapping" element={<MappingWrapper />} />
                    </Routes>
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default Registers;
